export const GET_SOFT_COLLECT_LIST = 'GET_SOFT_COLLECT_LIST';
export const SET_SOFT_COLLECT_LIST = 'SET_SOFT_COLLECT_LIST';
export const GET_SPECIAL_COLLECT_LIST = 'GET_SPECIAL_COLLECT_LIST';
export const UPDATE_SPECIAL_COLLECT_LIST = 'UPDATE_SPECIAL_COLLECT_LIST';
export const SET_SPECIAL_COLLECT_LIST = 'SET_SPECIAL_COLLECT_LIST';
export const UPDATE_SOFT_COLLECT_LIST = `UPDATE_SOFT_COLLECT_LIST`;

export const SET_COLLECT_LOADING = `SET_COLLECT_LOADING`;
export const ADD_COLLECT_SPECIAL_SOFT = 'ADD_COLLECT_SPECIAL_SOFT';
export const DELETE_COLLECT_SPECIAL_SOFT = 'DELETE_COLLECT_SPECIAL_SOFT';
